//Queue action
import { QueueActionTypes, AddQueues, ModifyQueues, DeleteQueues } from 'Actions/ActionTypes/queues';
import { Queue, Id } from 'NSwag/ServerClient/Client.nswag';

export const addQueues = (queues: Queue[]): AddQueues => ({
    type: QueueActionTypes.AddQueues as QueueActionTypes.AddQueues,
    queues
});

export const modifyQueues = (queues: Queue[]): ModifyQueues => ({
    type: QueueActionTypes.ModifyQueues as QueueActionTypes.ModifyQueues,
    queues
});

export const deleteQueues = (ids: Id[]): DeleteQueues => ({
    type: QueueActionTypes.DeleteQueues as QueueActionTypes.DeleteQueues,
    ids
});

export type QueueAction = ReturnType<typeof addQueues | typeof modifyQueues | typeof deleteQueues>